import { render, staticRenderFns } from "./CreateKokubanFolder.vue?vue&type=template&id=b30a2be2&scoped=true&"
import script from "./CreateKokubanFolder.vue?vue&type=script&lang=js&"
export * from "./CreateKokubanFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30a2be2",
  null
  
)

export default component.exports